import mfaAndResetActivationCodeEntryTemplate from "../core/mfaAndResetActivationCodeEntryTemplate";

const loginHelpActivationCodeEntryTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration">
    <header class="contained-form-header">
        <h1>
            {{"loginHelp"   | translate}}
            <!-- <span class="registration-progress">(3 of 4)</span> -->
        </h1>
        <p>{{ "codeSentMessage" | translate }}</p>
    </header>

    <div class="inner-container with-padding with-shadow">
        <form role="form" id="verficationForm" name="verficationForm" data-ng-submit="verifyCode('loginHelp')" novalidate autocomplete="off">
            
            ${mfaAndResetActivationCodeEntryTemplate}

            <a ui-sref="loginHelpDeliveryOptions" class="no-code" ng-click="noCodeClick()">{{"didNotRecieveCode"  | translate }}</a>
			  <div class="form-group clearfix">
                <button type="submit" class="btn btn-primary btn-lg btn-block margin-top-default" ng-disabled="showSpinner==true" id="signin">
                    <span data-ng-hide="showSpinner==true" id="signin">
                        Continue
                    </span>              
                    <span data-ng-show="showSpinner==true" id="signin">
                        <i class="fa fa-circle-o-notch fa-spin"></i>
                        Processing ...
                    </span>
                </button>
            </div>

        </form>
    </div><!--/inner-container with-padding with-shadow/-->
</div>
`;
export default loginHelpActivationCodeEntryTemplate;